import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaPlay, FaUsers, FaArrowRight } from 'react-icons/fa';
import { FiX } from 'react-icons/fi';

const Hero = ({ containerVariants, itemVariants }) => {
    const slides = [
        {
            image: "https://lh3.googleusercontent.com/pw/AP1GczMGEr5ldK8JVWIO9hgCpiludmVWBxetCM7K_r6uVQ0PyYhGPHw8dtp6nEmvLQZwwC0eJp0EwMIldy2WB4h0Cva-A9-xEhVecbCiVhLxC46Lc5LSGy9a-L0TgOtTwffvsJvTECbmY5_uHFX3Y1BtdhDnsg=w1159-h869-s-no-gm?authuser=0",
            title: <>O/L MASTER <br /><span className="text-gradient">THROUGH LOGIC</span></>,
            description: <>We don't just teach for the exam. We teach you to <span className="text-white italic">command</span> the logic of Grade 10 & 11 Mathematics.</>
        },
        {
            image: "https://lh3.googleusercontent.com/pw/AP1GczNwVBRmgTk8F88Hyz0wG0N0zDEnMFLmzKrgS70OmmgSaZRa8Bjk6gNL9l1x3zJtclz3q2KqWNH3a0gh_psDC961ZNgPtyM4mLGSxW0D6H9BAq5_yJbv08jKiT4mgGscdUQHPp0UpXAlKrEMgMLLf3e1Kg=w1159-h869-s-no-gm?authuser=0",
            title: <>A-PASS <br /><span className="text-gradient">IS AN ALGORITHM</span></>,
            description: <>Join the circle of O/L high-performers where mathematical precision ensures a guaranteed "A" grade.</>
        },
        {
            image: "https://lh3.googleusercontent.com/pw/AP1GczOQ9Gskbh7TdBn-OwVUWqNzfDHuj3i5qHFkecOMaGLi7fs8duCy-YgmrCJBeHut_MYtGslqjgkRaR3Ylydt_2gzxCQ6yqGAGRgO6b9NJV1_iCZ93jcDRUvymkswaTvt1QhSaEQmynjuwlinwV494BfAZQ=w651-h869-s-no-gm?authuser=0",
            title: <>SYLLABUS <br /><span className="text-gradient">MASTERY</span></>,
            description: <>From first principles of Algebra to complex Geometry, we provide the ultimate blueprint for O/L success.</>
        },
        {
            image: "https://lh3.googleusercontent.com/pw/AP1GczOQtalnnxbiM8iVWkMkyWJ_QjCOkYsef0P_UMsZ57vvXeC_BAb5N1WvvQVnRhpl-uwKIP2b16TEGzrPNIJcmK4FdSgofm6FBwk6N3My_hX7TDbcSPXNNWQCcLGBrh9gMJgM_PXZONSHtqPTNDw8LsWqjw=w1159-h869-s-no-gm?authuser=0",
            title: <>DIGITAL <br /><span className="text-gradient">REVISION 2.0</span></>,
            description: <>Utilizing advanced digital payloads to make every O/L mathematical concept crystal clear and memorable.</>
        }
    ];

    const [currentIndex, setCurrentIndex] = useState(0);
    const [showVideo, setShowVideo] = useState(false);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % slides.length);
        }, 8000);
        return () => clearInterval(timer);
    }, []);

    return (
        <section className="relative min-h-[100vh] flex items-center justify-center pt-20 overflow-hidden bg-[#0a0a0a]">
            {/* Slideshow Layer */}
            <div className="absolute inset-0 z-0">
                <AnimatePresence mode="wait">
                    <motion.div
                        key={currentIndex}
                        initial={{ opacity: 0, scale: 1.1 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        transition={{ duration: 2, ease: "easeInOut" }}
                        className="absolute inset-0"
                    >
                        <div
                            className="w-full h-full bg-cover bg-center"
                            style={{ backgroundImage: `url(${slides[currentIndex].image})` }}
                        />
                    </motion.div>
                </AnimatePresence>

                {/* Animated Background Accents */}
                <div className="absolute inset-0">
                    <motion.div
                        animate={{
                            scale: [1, 1.2, 1],
                            x: [0, 50, 0],
                            y: [0, 30, 0]
                        }}
                        transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
                        className="absolute top-[-20%] left-[-10%] w-[60%] h-[60%] bg-blue-900/90 blur-[150px] rounded-full"
                    ></motion.div>
                    <motion.div
                        animate={{
                            scale: [1.2, 1, 1.2],
                            x: [0, -40, 0],
                            y: [0, -20, 0]
                        }}
                        transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
                        className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] bg-indigo-600/5 blur-[120px] rounded-full"
                    ></motion.div>
                </div>

                {/* Overlays */}
                <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-10 mix-blend-overlay"></div>
                <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a]/20 via-[#0a0a0a]/50 to-[#0a0a0a]/80"></div>
                <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a]/30 via-transparent to-[#0a0a0a]/40"></div>
            </div>

            <motion.div
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="relative z-10 max-w-7xl mx-auto px-6 text-center"
            >
                <div className="mb-10">
                    <motion.div
                        variants={itemVariants}
                        className="inline-flex items-center gap-3 px-5 py-2.5 rounded-full bg-white/[0.03] border border-white/[0.08] backdrop-blur-md text-blue-400 text-[10px] font-black tracking-[0.2em] uppercase shadow-xl"
                    >
                        <span className="relative flex h-2.5 w-2.5">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-blue-500 shadow-[0_0_10px_rgba(59,130,246,0.8)]"></span>
                        </span>
                        Premium Mathematics Education
                    </motion.div>
                </div>

                <div className="min-h-[300px] flex flex-col items-center justify-center">
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={currentIndex}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -20 }}
                            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                            className="w-full"
                        >
                            <h1 className="text-4xl md:text-7xl font-black leading-[1.05] tracking-tighter mb-8">
                                {slides[currentIndex].title}
                            </h1>

                            <p className="text-base md:text-xl text-neutral-400 max-w-2xl mx-auto mb-12 leading-relaxed font-medium">
                                {slides[currentIndex].description}
                            </p>
                        </motion.div>
                    </AnimatePresence>
                </div>

                <motion.div
                    variants={itemVariants}
                    className="flex flex-col sm:flex-row gap-6 justify-center items-center"
                >
                    <Link to="/login" className="w-full sm:w-auto">
                        <motion.button
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            className="w-full sm:w-auto px-12 py-6 bg-blue-600 hover:bg-blue-700 text-white font-black text-sm rounded-[1.5rem] transition-all shadow-[0_20px_40px_rgba(37,99,235,0.25)] flex items-center justify-center gap-3"
                        >
                            Start Your Journey <FaArrowRight className="text-xs" />
                        </motion.button>
                    </Link>
                    <motion.button
                        whileHover={{ scale: 1.02, backgroundColor: 'rgba(255,255,255,0.08)' }}
                        whileTap={{ scale: 0.98 }}
                        onClick={() => setShowVideo(true)}
                        className="w-full sm:w-auto px-12 py-6 bg-white/[0.03] border border-white/10 backdrop-blur-xl text-white font-black text-sm rounded-[1.5rem] transition-all flex items-center justify-center gap-3"
                    >
                        <FaPlay className="text-[10px] text-blue-500" /> Watch Trailer
                    </motion.button>
                </motion.div>
            </motion.div>

            {/* Floating Decorative Elements */}
            <motion.div
                animate={{ y: [0, -20, 0] }}
                transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
                className="absolute right-[10%] top-[40%] hidden lg:block"
            >
                <div className="glass-card p-6 border-blue-500/20 shadow-blue-500/10 rotate-3">
                    <div className="text-blue-500 font-black text-4xl mb-1">98%</div>
                    <div className="text-[10px] text-neutral-500 uppercase font-black tracking-widest">Success Rate</div>
                </div>
            </motion.div>

            <motion.div
                animate={{ y: [0, 20, 0] }}
                transition={{ duration: 7, repeat: Infinity, ease: "easeInOut", delay: 1 }}
                className="absolute left-[10%] bottom-[20%] hidden lg:block"
            >
                <div className="glass-card p-6 border-indigo-500/20 shadow-indigo-500/10 -rotate-6">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center"><FaUsers /></div>
                        <div>
                            <div className="text-white font-black text-xl mb-0">10,000+</div>
                            <div className="text-[8px] text-neutral-500 uppercase font-black tracking-widest">Active Learners</div>
                        </div>
                    </div>
                </div>
            </motion.div>

            {/* Video Popup Modal */}
            <AnimatePresence>
                {showVideo && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-10"
                    >
                        {/* Backdrop */}
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            onClick={() => setShowVideo(false)}
                            className="absolute inset-0 bg-black/90 backdrop-blur-2xl"
                        />

                        {/* Modal Content */}
                        <motion.div
                            initial={{ opacity: 0, scale: 0.9, y: 20 }}
                            animate={{ opacity: 1, scale: 1, y: 0 }}
                            exit={{ opacity: 0, scale: 0.9, y: 20 }}
                            transition={{ type: "spring", damping: 25, stiffness: 300 }}
                            className="relative w-full max-w-6xl aspect-video bg-neutral-900 rounded-[2rem] overflow-hidden shadow-2xl shadow-blue-500/10 border border-white/10 z-10"
                        >
                            {/* Close Button */}
                            <button
                                onClick={() => setShowVideo(false)}
                                className="absolute top-6 right-6 z-20 w-12 h-12 bg-white/10 hover:bg-white/20 backdrop-blur-xl text-white rounded-full flex items-center justify-center transition-all group"
                            >
                                <FiX className="text-xl group-hover:rotate-90 transition-transform duration-300" />
                            </button>

                            {/* Video Iframe */}
                            <div className="w-full h-full relative group">
                                <iframe
                                    src="https://www.youtube.com/embed/NWYxTEPs02M?si=pNe8PDfEyzH0VMCQ"
                                    title="Mathematics Trailer"
                                    className="w-full h-full border-none"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </section>
    );
};

export default Hero;
